module.exports = __webpack_public_path__ + "static/media/8base-appbuilder-promo.aeb24605.png";